<template>
	<div>
		<Header :sel='type' @changePhone="changePhone" />
		<div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
			<!--新闻中心-->
			<div class="bg2">
				<div class="main3">
				    <div class="bread">
				      <div class="bread_t">{{memberType==1?'财产险公司':'人身险公司'}}</div>
				      <div class="bread_c"><a href="javascript:void(0)" @click="goNext('/')">主页</a> > <a href="javascript:void(0)">{{memberType==1?'财产险公司':'人身险公司'}}</a> </div>
				    </div>
				    <div class="main_line2">&nbsp;</div>
				    <div class="neirong_c">
				    <ul class="logo_list2">
						
						<li v-for="item in list"><a :href="item.url" target="_blank"><img 
									:src="item.logo" class="logo-img"/></a></li>
				   
				    </ul>
				      <ul id="page">
				      	<li><a href="javascript:void(0)" @click="goPage('home')">首页</a></li>
				      	<li><a href="javascript:void(0)" @click="goPage('last')">上一页</a></li>
				      	<li v-for="index in indexs" @click="goPage(index)"><a
				      			:class="pageNum==index?'pagesel':''" href="javascript:void(0)">{{index}}</a>
				      	</li>
				      	<li><a href="javascript:void(0)" @click="goPage('next')">下一页</a></li>
				      	<li><a href="javascript:void(0)" @click="goPage('end')">尾页</a></li>
				      	<li class="total">共{{totalPage}}页</li>
				      </ul>
				    </div>
				 
				</div>
				<div class="clear"></div>
			</div>
			<!--新闻中心-->
			<Footer></Footer>

		</div>


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import {
		categorysortPage,
		memberPageList,
		articleDetail
	} from '@/api/reqFetch.js'
	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header
		},
		data() {
			return {
				tabList: [],
				selName: '',
				selid: '0',
				list: [],
				pageNum: 1,
				indexs: [],
				totalPage: 0,
				showPhone: false,
				type: '',
				categoryCode: '',
				configList: [],
				selOneName: '',
				title: '',
				total: 0,
				level: 1,
				firstCategoryCode: '',
				pos: '',
				xhDetail: {},
				id: '',
				memberType:''
			}
		},

		mounted() {
			this.memberType=this.$route.query.memberType
			this.getData()

		},

		methods: {
			
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},

			
			checkIndex() {
				var left = 1;
				var right = this.totalPage;
				var ar = [];
				if (this.totalPage >= 10) {
					if (this.pageNum > 1 && this.pageNum < this.totalPage - 2) {
						left = this.pageNum - 1
						right = this.pageNum + 1
					} else {
						if (this.pageNum <= 1) {
							left = 1
							right = 10
						} else {
							right = this.totalPage
							left = this.totalPage - 2
						}
					}
				}
				while (left <= right) {
					ar.push(left)
					left++
				}
				this.indexs = ar

			},
			goNext(url) {
				this.$router.push({
					path: url,
				})
			},
			changePhone(val) {
				this.showPhone = val
			},
			goPage(type) {
				if (type == 'home') {
					this.pageNum = 1
				} else if (type == 'end') {
					this.pageNum = Number(this.totalPage)

				} else if (type == 'last') {
					if (this.pageNum > 1) {
						this.pageNum = this.pageNum - 1
					}
				} else if (type == 'next') {
					if (this.pageNum < (this.totalPage)) {
						this.pageNum = this.pageNum + 1
					}
				} else {
					this.pageNum = type
				}
				this.getData()
			},
			
			getData() {
				let par = {
					pageNum: this.pageNum,
					pageSize: 12,
					memberType: this.memberType,
				}
				memberPageList(par).then(res => {
					this.list = res.rows;
					this.total = res.total
					this.totalPage = Math.ceil(res.total / 12)
					this.checkIndex();
					
				});
			},
			
		}
	}
</script>

<style scoped>
	.logo-img {
		width: 180px;
		height: 55px;
		flex-shrink: 0
	}
</style>